import {
  payWithBankAccount,
  payWithCard,
  payWithWallet,
  updatePaymentMethod,
  updatePayoutMethod,
} from "../../services/api";
import {
  formatMethodsForPaymentIntent,
  formatMethodsForPayoutIntent,
  formatPaymentResponse,
  formatPayoutResponse,
} from "./utils";

export const sdkProceedWith = async ({
  proceedWith,
  intentType,
  intentId,
  id,
  lang,
  useWalletBalance,
  metaData,
  installmentPlanData,
  loyaltyData,
}: {
  proceedWith: "method" | "customerBalance" | "savedCard" | "savedBankAccount";
  intentType: "payment" | "payout";
  intentId: string;
  id: PaymentMethodSlugs;
  lang: string;
  useWalletBalance?: boolean;
  metaData?: {
    cvv: string;
  };
  installmentPlanData?: {
    planId: string;
    issuerCode?: string;
  };
  loyaltyData?: LoyaltyPayload;
}) => {
  if (proceedWith === "customerBalance") {
    const response = await payWithWallet(intentId, lang, loyaltyData);
    return {
      ...formatPaymentResponse(response),
      methods: formatMethodsForPaymentIntent(response),
    };
  }

  if (proceedWith === "savedCard") {
    const response = await payWithCard({
      intentId,
      cardToken: id,
      lang,
      cvv: metaData?.cvv,
      useWalletBalance,
      installmentPlanData,
      loyaltyData,
    });
    return {
      ...formatPaymentResponse(response),
      methods: formatMethodsForPaymentIntent(response),
    };
  }

  if (proceedWith === "savedBankAccount") {
    const response = await payWithBankAccount({
      intentId,
      bankToken: id,
      lang,
      loyaltyData,
    });
    return {
      ...formatPaymentResponse(response),
      methods: formatMethodsForPaymentIntent(response),
    };
  }

  if (intentType === "payment") {
    const response = await updatePaymentMethod(
      intentId,
      lang,
      id,
      useWalletBalance,
      loyaltyData
    );
    return {
      ...formatPaymentResponse(response),
      methods: formatMethodsForPaymentIntent(response),
    };
  }

  const response = await updatePayoutMethod(intentId, lang, id);

  return {
    ...formatPayoutResponse(response),
    methods: formatMethodsForPayoutIntent(response),
  };
};
